import React                      from 'react';
import { connect }                from 'react-redux';
import { reducerType }            from 'reducer';
import { approvedUserStateType }  from 'types';
import useGetGreeting             from 'functions/get_greeting';
import { makeStyles }             from '@material-ui/core/styles';

const title0     = "יישומטיקה - רישום משתמשים";
const title      = "הזן כתובת דוא״ל";
const title2     = "שם המוסד";
const backendErr = "שגיאה בהעלאת המידע. אנא נסו שוב במועד מאוחר יותר";

const useStyles = makeStyles(() => ({
   /*  container: {
        position:        'absolute',
        left:            0,
        top:             60,
        width:           '100vw',
        overflowY:       'scroll',
        overflowX:       'hidden',
        transition:      'opacity 0.3s',
        '&::-webkit-scrollbar': {
          width: '0.5em',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: `#BBB`,
          borderRadius:    10
        }
    }, */
    root: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        backgroundColor: '#FFF'
    },
    title0: {
        display:         'flex',
        alignItems:      'center',
        marginTop:       30,
        justifyContent:  'center',
        cursor:          'default',
        height:          40,
        fontSize:        20,
     },
     greeting: {
        display:         'flex',
        alignItems:      'center',
        marginTop:       30,
        justifyContent:  'center',
        cursor:          'default',
        fontSize:        16,
        maxWidth:        '80vw',
        wordBreak:       'break-all',
     },
    title: {
       display:         'flex',
       alignItems:      'center',
       width:           450,
       textAlign:       'right',
       cursor:          'default',
       height:          40,
       fontSize:        18,
    },
    error: {
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       cursor:          'default',
       height:          40,
       fontSize:        18,
       color:           '#E00'
    },
    input: {
        width:     450,
      //  height:    '15vh',
        height:    40,
        minWidth:  450,
       // minHeight: 100,
        fontSize:  18,
    },
    textField: {
        width:     450,
        height:    40,
      //  minWidth:  350,
        fontSize:  18,
    },
    gradeContainer: {
        width:           '55vw',
        height:          80,
        minWidth:        350,
        minHeight:       100,
        fontSize:        18,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
    },
    grade: {
        width:           45,
        height:          45,
        marginRight:     5,
        marginLeft:      5,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        backgroundColor: '#45C',
        color:           '#FFF',
        fontWeight:      'bold',
        cursor:          'pointer'
    },
    plus: {
        width:           375,
        height:          45,
        marginRight:     5,
        marginLeft:      5,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        backgroundColor: '#45C',
        color:           '#FFF',
        fontWeight:      'bold',
        cursor:          'pointer',
        marginBottom:    40
    },
    button: {
       width:           200,
       height:          45,
       margin:          20,
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       color:           '#FFF',
       backgroundColor: '#45C',
       fontWeight:      'bold',
       cursor:          'pointer',
       '&:hover': {
          opacity: 0.9
       }
    }
}))


type InputPropsType = {
    size:                 number[];
    state:                approvedUserStateType;
    error:                string;
    showError:            boolean;
    showOrgNameTextField: boolean;
    setState:             ( val: approvedUserStateType ) => void;
    handleSubmit:         () => void;
}

const Input: React.FC<InputPropsType> = ({ 
    size, 
    state, 
    error, 
    showError, 
    showOrgNameTextField,
    setState, 
    handleSubmit 
}) => {

    const classes = useStyles();

    const greeting = useGetGreeting();

    const changeInputValue = (e: React.FormEvent) => {

        e.preventDefault();
    
        const target = e.target as HTMLInputElement;
    
        if (target.id === 'emailStr') { setState({ ...state, emailStr: target.value }) }
        if (target.id === 'org_name') { setState({ ...state, org_name: target.value }) }    
    }

    return(
        <div className = { classes.root }>
            <div 
               dir       = 'rtl'
               className = { classes.title0 }
            >
                   { title0 }
            </div>
            {
                !!greeting.length &&
                <div 
                   dir       = 'rtl'
                   className = { classes.greeting }
                >
                        { greeting }
                </div>
            }
            <div
               dir       = 'rtl'
               className = { classes.error }
            >
                { showError ? backendErr : error }
            </div>
            <div 
               dir       = 'rtl'
               className = { classes.title }
            >
                   { title }
            </div>
            <textarea 
               className   = { classes.input }
               id          = { 'emailStr' }
               placeholder = { 'example@aaa.com' }
               value       = { state.emailStr }
               onChange    = { changeInputValue }
            />
            {
                showOrgNameTextField &&
                <>
                    <div 
                       dir       = 'rtl'
                       className = { classes.title}
                    >
                        { title2 }
                    </div>
                    <input 
                       className   = { classes.textField }
                       id          = { 'org_name' }
                       value       = { state.org_name }
                       onChange    = { changeInputValue }
                    />
                </>
            }
             
            <div
               className = { classes.button }
               onClick   = { handleSubmit }
            >
                אישור
            </div>
        </div>
    )
}



const mapStateToProps = (reducer: reducerType) => {

    return {
        showOrgNameTextField: reducer.showOrgNameTextField,
    }
  };
  

  export default connect(mapStateToProps)(Input);

  
